import { NotificationSeverity } from "helpers/constants";
import { useAppDispatch } from "./useAppDispatch";
import { showNotificationThunk } from "reduxStore/alert/thunks";

export const useNotifications = () => {
  const dispatch = useAppDispatch();

  const notify = ({
    message,
    severity,
  }: {
    message: string;
    severity: NotificationSeverity;
  }) => {
    dispatch(
      showNotificationThunk({
        message,
        severity,
      }),
    );
  };

  return { notify };
};
